import { AxiosResponse } from "axios";
import { BULKORDER_SHIPPING_ADDRESS_ENDPOINTS } from "../constants/apiEndpoints";
import { appContextPost } from "./httpCommon/appAxios.service";

export const addBulkOrderShippingAddress = (bulkordershippingaddress: {}): Promise<AxiosResponse<any, any>> => {
    return appContextPost(BULKORDER_SHIPPING_ADDRESS_ENDPOINTS.ADD_SHIPPING_ADDRESS, bulkordershippingaddress);
};